import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
  forwardRef,
  useImperativeHandle,
  Component,
} from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAssetSettings } from "../../../actions/assetSettingsAction";
import { getAssestListddlAction } from "../../../actions/assetsddlAction";
import { getAssetAttributes } from "../../../actions/assetAttributesActions";
import { AssetDropDown } from "../../../UiComponents/AssetDropDown";
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { getAsset } from "../../../actions/assetAction";
import { useNavigate, useParams } from "react-router-dom";
import {
  FullScreenLoadingScreen,
  LoadingScreen,
} from "../../../UiComponents/LoadingComponent";
import { DateInput, DatePicker } from "@progress/kendo-react-dateinputs";
import { UrlPath } from "../../../../config/routeConfig";
import { TopBar } from "../../../shared/topBar/TopBar";
import { AgGridReact } from "ag-grid-react";
import { getAssetValuation } from "../../../actions/postReturnsAction";
import {
  insertUpdateAssetValuation,
  DeleteAssetValuation,
  getAssetLotsUrl,
  portfolioPostReturns,
  updateImportReturns,
  DownloadImportReturnsTemplate
} from "../../../../config/apiConfig";
import { ToastContainer, toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { sbaAxios } from "../../../utils/sbaAxios";
import { SBAComboBox } from "../../../UiComponents/SBADropDown";
import { SBATreeList } from "../../../UiComponents/SBATreeList";
import { SBNotify } from "../../../utils/sbNotify";
import { getUserPageAccess } from "../../../../config/apiConfig";
import { SBDatePicker } from "../../../UiComponents/SBDatePicker";
import { SBADrawer } from "../../../UiComponents/SBADrawer";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
export const PostPricing = () => {

  const emptyImportReturns = {
    selectedFile: null,
    FundLots: false,
    ExistingData: false,
    FinalReturns: false,
  }

  const Gstate = useSelector((state) => state) || {};
  const isEditable = Gstate.authorizationData.isEditable;
  const assetValuationData = Gstate?.PostReturns?.assetValuationData || [];
  const locationData = useLocation();
  const gridRef = useRef();
  const [Loading, setLoading] = useState(true);
  const [render, setRender] = useState(true);
  const [buttonGo, setbuttonGo] = useState(true);
  const [isChecked, setIsChecked] = useState(true);
  const [selectedLotListButton, setLotListButton] = useState(
    locationData.state === null ? 3 : locationData.state?.ReportingFrequencyId
  );
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [selectedFrequencyId, setSelectedFrequencyId] = useState(
    locationData.state?.ReportingFrequencyId
  );
  const [selectedTimeSeries,setSelectedTimeSeries] = useState(
    locationData.state?.SelectedTimeSeries
  );
  const [rorValuationId, setRorValuationId] = useState();
  const [navValuationId, setNavValuationId] = useState();
  const [showModal, setShowModal] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [updateGridData, setUpdateGridData] = useState(0);
  const [assetLots, setAssetLots] = useState([]);
  const [includeLots, setIncludeLots] = useState(false);
  const [lotsDropdownData, setLotsDropDownData] = useState([]);
  const [enableLots, setenableLots] = useState(false);
  const [allLotsChecked, setAllLotsChecked] = useState(false);
  const [selectedLot, setSelectedLot] = useState({
    ShareClassName: "Composite",
    ShareClassId: 0,
  });

  const [importReturnsDrawer, setImportReturns] = useState(false);
  const [drawerData, setDrawerData] = useState(emptyImportReturns);
  const [workbookFile, setWorkbookFile] = useState(null);
  const [importStatus, setImportStatus] = useState('Import');

  // const [filterDate, setFilterDate] = useState(new Date());
  // const [LocalDate1, setLocalDate] = useState(new Date());
  const [PostReturnsLotRuleAccess, setPostReturnsLotRuleAccess] =
    useState(false);
  const [saveDataLV, setSaveDataLV] = useState([]);
  const [importselectedLot,setImportSelectedLot]=useState({
    ShareClassName: "Composite",
    ShareClassId: 0,
  })
  //let saveDataLV = [];
  let LocalDate = selectedDate;
  const [filterDate, setFilterDate] = useState(LocalDate);
  //const [filterDate, setFilterDate] = useState(LocalDate)
  const [IsMarketable, setIsMarketable] = useState(false);
  const [toSave,setToSave]=useState({mode:"save",flag:false});
  const getPostReturnsLotAccess = () => {
    sbaAxios({ url: `${getUserPageAccess}?keyName=PostReturnsLotAccess` })
      .then((response) => {
        setPostReturnsLotRuleAccess(response);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  useEffect(() => {
    getPostReturnsLotAccess();
  }, []);

  const formattedSelectDate = moment(filterDate).format("MM-DD-yyyy");
  const params = useParams();
  const history = useNavigate();
  const dispatch = useDispatch();
  const getAssetLots = () => {

    sbaAxios({ url: `${getAssetLotsUrl}${params.Asset}` })
      .then((response) => {
        const DataSourceFortree = response.map((item, index) => {
          return {
            ...item,
            text: item.ShareClassName,
            LotId: index,
            checked: false,
            expanded: false,
            items: item.AssetLotList.map((subItem) => {
              return {
                AssetLotId: subItem.AssetLotId,
                PortfolioId: subItem.PortfolioId,
                text: subItem.DisplayName,
                DisplayName: "Class A - 01/01/2020 - Cracktuxet LLC",
                ShareClassId: subItem.ShareClassId,
                checked: false,
                LotId: index,
              };
            }),
          };
        });
        setAssetLots(DataSourceFortree);
        const assetlotArrays = response.map((item) => item.AssetLotList);
        const combinedArray = [].concat(...assetlotArrays);
        setLotsDropDownData(combinedArray);
        if(selectedTimeSeries!=null && selectedTimeSeries!=-1 )
        {
        const dt=  combinedArray.filter(item => item.ShareClassId === selectedTimeSeries)
         if(dt.length>0)
         {
          setSelectedLot({ShareClassName:dt[0].ShareClassName,
            ShareClassId: dt[0].ShareClassId});
            dispatch(
              getAssetValuation(
                256,
                dt[0].ShareClassId,
                selectedFrequencyId,
                filterDate.toISOString()
              )
            );
         }
          
        }
        else
        {
          setSelectedLot({
            ShareClassName: "Composite",
            ShareClassId: 0,
          });
          dispatch(
            getAssetValuation(
              1,
              params.Asset,
              selectedFrequencyId,
              filterDate.toISOString()
            )
          );
      
      
        }
       
      })
      .catch((e) => {
        console.log(e, "Asset lots get Error");
      });
      
  };
  useEffect(() => {
    setGridData(assetValuationData);
  }, [assetValuationData]);
  useEffect(() => {
    if (updateGridData !== 0)
    if(selectedLot.ShareClassId===0 ||selectedTimeSeries!=-1 )
    {
      dispatch(
        getAssetValuation(1, params.Asset, selectedFrequencyId, moment(filterDate).format("MM-DD-yyyy"))
      );
    }
    else
    {
      dispatch(
        getAssetValuation(256, selectedLot.ShareClassId, selectedFrequencyId, moment(filterDate).format("MM-DD-yyyy"))
      );
    }
  }, [updateGridData]);

  useEffect(() => {
    currentAsset && AssetListDDL && setLoading(false);
    getIsMarketable(currentAsset.AssetId);
  }, [Gstate]);

  useEffect(() => {
    document.title = `Post Returns`;
    dispatch(getAssestListddlAction());
    dispatch(getAsset(params.Asset));
    dispatch(getAssetSettings(params.Asset));
    dispatch(getAssetAttributes(params.Asset));
  }, [render]);

  //button trigger here for initial load
  useEffect(() => {
    // enterButtonClick();
    getAssetLots();
  }, [params]);

  const AssetListDDL = Gstate.assetDDL.assetList || [];

  const currentAsset = Gstate.asset.asset || {};
  const Attributes = Gstate.attributesDetails.attributesDetails || [];

  const getIsMarketable = (Id) => {
    const dt = AssetListDDL.filter(
      (item) => item.AssetId === Id
    );
    setIsMarketable(dt[0]?.IsMarketable);
  }
  const AssestDDChanged = (e) => {
    setRender(!render);
    e.value
      ? history(`${UrlPath.PostPricing}${e.value.AssetId}`, {
        state: { ReportingFrequencyId: Attributes?.ReportingFrequencyId },
      })
      : history(`${UrlPath.PostPricing}${params.Asset}`, {
        state: { ReportingFrequencyId: Attributes?.ReportingFrequencyId },
      });
      setSelectedLot({
        ShareClassName: "Composite",
        ShareClassId: 0,
      });
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.value);
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const lotSeriesColumnDefs = [
    { headerName: "Lot Series Name", field: "" },
    { headerName: "Date", field: "" },
  ];

  //Clear All
  const clearButtonClick = (e) => { };

  const enterButtonClick = () => {
    setSelectedDate(LocalDate);
    if(selectedLot.ShareClassId===0)
    {
    dispatch(
      getAssetValuation(
        1,
        params.Asset,
        selectedFrequencyId,
        filterDate.toISOString()
      )
    );
      }
      else
      {
        dispatch(
          getAssetValuation(
            256,
          selectedLot.ShareClassId,
            selectedFrequencyId,
            filterDate.toISOString()
          )
        );
      }
  };

  const benchmarkingPerfButtonClick = (buttonId) => {
    setLotListButton(buttonId);
    setSelectedFrequencyId(buttonId);
    if(selectedLot.ShareClassId===0)
    {
    dispatch(getAssetValuation(1, params.Asset, buttonId, formattedSelectDate));
    }
    else
    {
      dispatch(getAssetValuation(256, selectedLot.ShareClassId, buttonId, formattedSelectDate));
    }
    if (buttonId === 1 || buttonId === 2 || buttonId === 15)
      setenableLots(true);
    else
      setenableLots(false);
  };

  const DeleteButtonRenderer = (props) => {
    const Id = props.data;

    const handleDeleteClick = () => {
      setShowModal(true);
      setRorValuationId(Id.RorValuationId);
      setNavValuationId(Id.NavValuationId);
    };

    return (
      <div className="actions-cell">
        <i
          className="fas fa-trash"
          style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
          onClick={handleDeleteClick}
        ></i>
      </div>
    );
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const onDeleteButtonClick = () => {
    setShowModal(false);
    sbaAxios({
      url: `${DeleteAssetValuation}?rorValuationId=${rorValuationId}&navValuationId=${navValuationId}`,
    })
      .then((response) => {
        if (response === -4444 || response === -3333) {
          closeModal();
          toast.error("Delete Failed", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          closeModal();
          toast.success("Return Delete Successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setTimeout(() => {
            enterButtonClick();
          }, 100);
        }
      })
      .catch((error) => {
        console.error("Error deleting data:", error);
      });
  };

  const buttonNames = [
    { buttonIds: 1, name: "1D" },
    { buttonIds: 2, name: "1W" },
    { buttonIds: 15, name: "Mid-Month" },
    { buttonIds: 3, name: "1M" },
    { buttonIds: 4, name: "Qtr" },
  ];

  const LotListButtons = buttonNames.map((button, index) => (

    <button
      key={index}
      id={`button-${button.buttonIds}`}
      className={`non-gappable-button ${selectedLotListButton === button.buttonIds
          ? "selected-non-gappable-button"
          : ""
        }`}
      onClick={() => benchmarkingPerfButtonClick(button.buttonIds)}
    >
      {button.name}
    </button>

  ));

  const formatDate = (params) => {
    const dateValue = params.value;
    if (dateValue) {
      return <div>{moment(dateValue).format("MM/DD/YYYY")}</div>; // Adjust the format as needed
    }
    return <div></div>;
  };

  const formatNumber = (params) => {
    const numberValue = params.value;
    if (typeof numberValue === "number") {
      return new Intl.NumberFormat().format(numberValue);
    }
    return;
  };

  const formatDecimal = (params) => {
    const decimalValue = params.value;
    if (typeof decimalValue === "number") {
      return new Intl.NumberFormat(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(decimalValue);
    }
    return;
  };

  const onCellValueChanged = async (e) => {
    try {
      const updatedData = [...saveDataLV];
      const rowIndex = updatedData.findIndex(
        (item) => item.ValuationDate === e.data.ValuationDate
      );
      if (rowIndex < 0) {
        updatedData.push(e.data);
      } else {
        updatedData[rowIndex] = e.data;
      }
      // saveDataLV = [...updatedData];
      setSaveDataLV(val=>[...updatedData]);
      if(toSave.flag)
      saveRequest(updatedData,toSave.mode);
      // ((prevData) => {
      //   const updatedData = [...prevData];
      //   const rowIndex = updatedData.findIndex(
      //     (item) => item.ValuationDate === e.data.ValuationDate
      //   );
      //   if (rowIndex < 0) {
      //     updatedData.push(
      //       e.data
      //     );
      //   } else {
      //     updatedData[rowIndex] =
      //       e.data


      //   }
      //   return updatedData;
      // });
    } catch (error) {
      console.error("Error while saving data:", error);
    }
  };

  const finalcheckChange = (e, params) => {
    setGridData((prevData) =>
      prevData.map((item) => {
        if (item.ValuationDate === params.data.ValuationDate) {

          return {
            ...item,
            EstimateActual: e.target.checked === true ? 'A' : 'E',


          };
        }
        return item;
      })
    );
    try {
      // const updatedData = [...saveDataLV];
      // const rowIndex = updatedData.findIndex(
      //   (item) => item.ValuationDate === params.data.ValuationDate
      // );
      // if (rowIndex < 0) {
      //   updatedData.push({...params.data, EstimateActual:  e.target.checked===true?'A':'E'});
      // } else {
      //   updatedData[rowIndex] = { ...params.data, EstimateActual: e.target.checked===true?'A':'E' };

      // }
      // saveDataLV = [...updatedData];
      setSaveDataLV((prevData) => {
        const updatedData = [...prevData];
        const rowIndex = updatedData.findIndex(
          (item) => item.ValuationDate === params.data.ValuationDate
        );
        if (rowIndex < 0) {
          updatedData.push({
            ...params.data,
            EstimateActual: e.target.checked === true ? 'A' : 'E',
          });
        } else {
          updatedData[rowIndex] = {
            ...params.data,
            EstimateActual: e.target.checked === true ? 'A' : 'E',
          };
        }
        return updatedData;
      });


    } catch (error) {
      console.error("Error while saving data:", error);
    }


  }
  const CheckboxRendererMenu = (props) => {
    return (
      <div className="d-flex justify-content-start align-items-center h-100" style={{ paddingLeft: '10px' }}>
        <input
          type="checkbox"
          checked={props.data.EstimateActual === 'A' ? true : false}
          onChange={(e) => { finalcheckChange(e, props) }}
        />
      </div>
    );
  };
  const listofDetailsColumnDefs = [
    /* {
           headerName: "Date",
           field: "ValuationDate",
           valueFormatter: formatDate,
           editable: false,
         },*/

    {
      headerName: "Price Date",
      field: "ValuationDate",
      cellRenderer: formatDate,
      editable: false,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Net Asset Value ($US)",
      field: "NavValue",
      valueFormatter: formatNumber,
      filter: "agTextColumnFilter",
      editable: true,

    },
    //{
    //  headerName: "Return (%)",
    //  field: "RorValue",
    //    valueFormatter: formatDecimal,
    //    singleClickEdit: true,
    //  //cellEditor: ReturnCellEditor,
    //  cellStyle: { textAlign: "right" },
    //    filter: "agTextColumnFilter",

    //},
    {
      headerName: "Return (%)",
      field: "RorValue",
      valueFormatter: params => {
        if (params && params.value !== undefined && params.value !== null) {
          const rawValue = params.value > 999 ? 999 : params.value;
          const formattedValue = parseFloat(rawValue).toFixed(2); // Adjust 2 to the desired number of decimal places
          return formattedValue;
        } else {
          // Handle the case where params or params.value is null or undefined
          return null; // or a default value or an empty string, depending on your requirements
        }
      },
      cellStyle: { textAlign: "right" },
      filter: "agTextColumnFilter",
    },



    {
      headerName: "Final",
      field: "EstimateActual",
      cellRenderer: CheckboxRendererMenu,
      maxWidth: 100,
      floatingFilter: false,
      editable: false,
    },
    {
      headerName: "Date Received",
      field: "ModifiedDate",
      filter: "agTextColumnFilter",
      cellRenderer: formatDate,
      cellEditor: DateEditor,
      editable: true,
    },
    {
      headerName: "Action",
      field: "Action",
      maxWidth: 100,
      cellRenderer: DeleteButtonRenderer,
      editable: false,
      filter: false,
    },
  ];

  const onSuppressKeyboardEvent = params => {
    let isTabKey = params.event.key === 'Tab';
    if (isTabKey) gridRef.current.api.stopEditing();
  };

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      editable: true,
      cellDataType: false,
      sortable: false,
      filter: true,
      suppressMovable: true,
      floatingFilter: true,
      singleClickEdit: true,
      suppressKeyboardEvent: onSuppressKeyboardEvent,
    };
  }, []);

  const isEditing = () => {
    const editingCells = gridRef.current.api.getEditingCells();
    return editingCells.length > 0;
  };
  const saveButtonClick=async()=>{
    setToSave({mode:"Save",flag:true});
    if(isEditing())
    await gridRef.current.api.stopEditing();
    else 
    {
      setTimeout(() => {
        saveRequest(saveDataLV,'Save');        
      }, 500);

    }
  };

  // const saveButtonClick = async (event) => {
  //   await gridRef.current.api.stopEditing();
  //   setTimeout(() => {
  //     saveRequest(saveDataLV, 'Save');
  //   }, 500);
  // };

  const saveandCloseButtonClick = async (event, type) => {
    setToSave({mode:"SaveClose",flag:true});
    if(isEditing())
    await gridRef.current.api.stopEditing();
    else 
    {
    setTimeout(() => {
      saveRequest(saveDataLV, 'SaveClose');
    }, 500);
    }
  };

  const saveRequest = (data, type) => {
    let checkedLot = [];
    assetLots.forEach((assetLot) => {
      const CheckedLots = assetLot.items
        .filter((lot) => lot.checked)
        .map((lot) => lot.AssetLotId);
      checkedLot = [...CheckedLots, ...checkedLot];
    });

    let saveSuccess = true;
    const processedData = data.map((item) => {
      const monthMinusOne = new Date();
      monthMinusOne.setMonth(monthMinusOne.getMonth() - 1);
      const dt = moment(monthMinusOne).format("YYYY-MM-DD");
      const valdate = moment(item.ValuationDate).format("YYYY-MM-DD");
      if (valdate < dt && includeLots) {
        SBNotify({ Msg: "Lots cannot be updated using this page for months prior to Month-1.", type: "error" });;
        saveSuccess = false;
        setSaveDataLV([]);
        setToSave({mode:"Save",flag:false});
      }
      else {
        return {
          rorValuationId: item.RorValuationId,
          navValuationId: item.NavValuationId,
          entityTypeId: selectedLot.ShareClassId==0? 1:256,
          entityId: selectedLot.ShareClassId==0? item.EntityId:selectedLot.ShareClassId,
          entityName: item.EntityName,
          frequencyId: selectedFrequencyId,
          valuationDate: item.ValuationDate,
          rorValue: parseFloat(item.RorValue),
          navValue: parseFloat(item.NavValue),
          estimateActual: item.EstimateActual,
          modifiedBy: 0,
          modifiedByName: item.ModifiedByName,
          modifiedDate: item.ModifiedDate,
        };
      }
    });
    if (saveSuccess) {
      processedData.map(async (item, index) => {
        const PortfolioValuationsReturn = {
          entityId: params.Asset,
          postingDate: item.valuationDate,
          roR: item.rorValue,
          lotsList: "string",
          assetLotList: [...checkedLot],
          modifiedBy: 0,
        };
        if (checkedLot.length > 0)
          sbaAxios({
            url: portfolioPostReturns,
            method: "post",
            data: PortfolioValuationsReturn,
          })
            .then()
            .catch((e) => {
              console.log(e, "Error saving data PortfolioValution return");
            });
        sbaAxios({ url: insertUpdateAssetValuation, method: "post", data: item })
          .then((response) => { })
          .catch(() => {
            saveSuccess = false;
            setToSave({mode:"Save",flag:false});
          });
      });

      if (saveSuccess) {
        SBNotify({ Msg: "Return saved successfully" });
        if (type === "SaveClose")
          cancelButtonClick();
        else
        {
          setTimeout(() => {
          if(selectedLot.ShareClassId===0)
          {

          dispatch(
            getAssetValuation(
              1,
              params.Asset,
              selectedFrequencyId,
              filterDate.toISOString()
            )
          );
            }
            else
            {
              dispatch(
                getAssetValuation(
                  256,
                selectedLot.ShareClassId,
                  selectedFrequencyId,
                  filterDate.toISOString()
                )
              );
            }
                 }, 500);
                }
        //   history(`${UrlPath.PostPricing}${params.Asset}`);
      } else {
        SBNotify({ Msg: "error saving data", type: "error" });
      }
      setSaveDataLV([]);
      setUpdateGridData((value) => value + 1);
    }
  };

  const cancelButtonClick = (e) => {
    history(`/${UrlPath.AssetReturnStatics}${params.Asset}`, {
      state: {
        ActiveTab: "ReturnsAndStatistics",
        currentAssetId: params.Asset,
        SelectedTimeSeries: selectedLot.ShareClassId===0?-1:selectedLot.ShareClassId,
      },
    });
  };

  let Level = [{ BreadCrumb: "Asset > ", Routes: `${UrlPath.Asset}` }];
  Level = Loading
    ? Level
    : [
      ...Level,
      {
        BreadCrumb: `${currentAsset.AssetName} >`,
        Routes: `${UrlPath.AssetDetails}${params.Asset}`,
      },
      {
        BreadCrumb: `Analytics >`,
        Routes: `/${UrlPath.AssetReturnStatics}${params.Asset}`,
      },
      {
        BreadCrumb: `Post Returns`,
        Routes: `/${UrlPath.PortfolioPricing}${params.Asset}`,
      },
    ];
  const updateParentDate = (e) => {
    LocalDate = e;
    // setSelectedDate(e.value)
    //   setFilterDate(selectedDate);
    // setLocalDate(selectedDate);
  };

  // const [filterDate, setFilterDate] = useState(LocalDate)
  const checkAndUnCheckAll = (value) => {
    const assetLot = [...assetLots];
    const updatedAssetLots = assetLot.map((item) => {
      return {
        ...item,
        checked: value,
        expanded: true,
        items: item.items.map((items) => ({ ...items, checked: value })),
        AssetLotList: item.items.map((items) => ({ ...items, checked: value })),
      };
    });
    setAssetLots([...updatedAssetLots]);
  };

  const afterExpand = (newData) => { };
  const afterCheck = () => { };
  const postPricingdateChange = (e) => {
    const changedDate = new Date(e);
    updateParentDate(changedDate);
    setFilterDate(changedDate);
  };

  const importReturnsClick = () => {
    setImportReturns(true);
    setImportSelectedLot(selectedLot);
  };

  const handleFileChange = (event) => {
    const { name } = event.target;
    const file = event.target.files[0];
    const updatedState = { ...drawerData, [name]: file };
    setDrawerData(updatedState);

    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const fileContent = event.target.result;

        const workbook = XLSX.read(fileContent, { type: 'binary', cellDates: true });
        setWorkbookFile(workbookToSheetsArray(workbook));
      };

      reader.readAsBinaryString(file);
    }
  };

  const workbookToSheetsArray = (workbook) => {
    const sheetsArray = [];
    workbook.SheetNames.forEach((sheetName) => {
      const sheet = workbook.Sheets[sheetName];
      const table = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      const formattedTable = formatTableWithNulls(table);
      sheetsArray.push({ name: sheetName, table: formattedTable });
    });
    return sheetsArray;
  };

  const formatTableWithNulls = (table) => {
    const headers = table[0];

    if (!validateHeaders(headers)) {
      return [];
    }

    return table.slice(1).map((row) => {
      const isRowEmpty = row.every((value) => value === undefined || value === null);
      if (isRowEmpty) {
        return null;
      }
      const formattedRow = {};
      headers.forEach((header, index) => {

        if (header === 'PriceDate') {
          const formattedDate = row[index];
          formattedRow[header] = formatExcelDate ? formatExcelDate(formattedDate) : null;
        } else {
          formattedRow[header] = row[index] === undefined ? null : row[index];
        }
      });
      return formattedRow;
    }).filter((row) => row !== null);
  };
  const formatExcelDate = (inputDate) => {

    const date = new Date(inputDate);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    const formattedMonth = month < 10 ? '0' + month : month;
    const formattedDay = day < 10 ? '0' + day : day;
    const formattedDate = `${formattedMonth}/${formattedDay}/${year}`;

    return formattedDate;
  };

  const validateHeaders = (headers) => {
    const requiredHeaders = ["AssetId", "EntityTypeId", "PriceDate", "NAV", "Ror", "EstimatedActual"];

    const missingHeaders = requiredHeaders.filter(header => !headers.includes(header));
    if (missingHeaders.length > 0) {
      return false;
    }
    return true;
  };

  const handleCheckbox = (e) => {
    const { name, checked } = e.target;
    const value = checked ? true : false;
    const updatedState = { ...drawerData, [name]: value };
    setDrawerData(updatedState);
  };

  const saveImportReturns = async () => {
    let saveSuccess = true;
    let errorMSG = `Invalid Final Value Flag`;
    if (workbookFile?.length > 0) {
      const mappedData = workbookFile[0].table.map((row) => ({
        EntityId: row.AssetId,
        EntityTypeId: row.EntityTypeId,
        ValuationDate: row.PriceDate
          ? moment(row.PriceDate).format("MM/DD/yyyy")
          : null,
        NAV: row.NAV,
        RoR: Number(parseFloat(row.Ror).toFixed(4)),
        ActualEstimate: row.EstimatedActual,
      }));

      const data = {
        mappedData
      };

      const isValidFinalValue = (value) => /^[AE]$/i.test(value);

      mappedData.forEach((row) => {
        if (!isValidFinalValue(row.ActualEstimate)) {
          errorMSG = "Invalid Final Value Flag";
          saveSuccess = false;
        }
      });

      // mappedData.forEach((row) => {
      //   if (params.Asset != row.EntityId || row.EntityTypeId !== 1) {
      //     errorMSG = "Please  Returns Data for the Selected Account";
      //     saveSuccess = false;
      //   }
      // });

      if (
        data.mappedData.length === 0 || data.mappedData === "") {
        errorMSG = "Invalid File Format";
        saveSuccess = false;
      }

      if (saveSuccess) {
        const response = await sbaAxios({
          url: `${updateImportReturns}`,
          method: "post",
          data: mappedData,
        });
        if (response > 0) {
          setImportReturns(false);

          if(selectedLot.ShareClassId===0)
          {

          dispatch(
            getAssetValuation(
              1,
              params.Asset,
              selectedFrequencyId,
              filterDate.toISOString()
            )
          );
            }
            else
            {
              dispatch(
                getAssetValuation(
                  256,
                selectedLot.ShareClassId,
                  selectedFrequencyId,
                  filterDate.toISOString()
                )
              );
            }
    
          SBNotify({ type: "success", Msg: "Import Successfully" });

        } else {
          SBNotify({ type: "warning", Msg: "Failed" });
        }
        setImportStatus('Import');
      }
      else {
        SBNotify({ type: "error", Msg: errorMSG });
        setImportStatus('Import');
      }
    }
    else {
      SBNotify({ type: "error", Msg: "Please Select Any File To Import" });
      setImportStatus('Import');
    }

  };

  const cancelImportReturns = () => {
    setImportReturns(false);
  };

  const gridOptions = {
    onFirstDataRendered: (params) => {
      // Select the first row by default
      params.api.forEachNode((node, index) => {
        if (index === 0) {
          node.setSelected(true);
        }
      });
    },
  };
  const rowDataUpdated = (params) => {
    params.api.forEachNode((node, index) => {
      if (index === 0) {
        node.setSelected(true);
      }
    });
  }
  const DownloadFile = async () => {
    // sbaAxios({
    //   url: DownloadImportReturnsTemplate,
    //   responseType: 'blob'
    // }).then((response) => {
    //   // var downloadLink = document.createElement('a');
    //   // downloadLink.href = URL.createObjectURL(response);
    //   // downloadLink.download = "ReturnImportTemplate.xlsx";
    //   // downloadLink.click();
    // });

    const response = await sbaAxios({
      url: DownloadImportReturnsTemplate,
      responseType: 'blob'
    });

const reader = new FileReader();
reader.readAsArrayBuffer(response);
reader.onload = (e) => {
  const data = new Uint8Array(e.target.result);
  const workbook = XLSX.read(data, { type: 'array' });
  const sheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[sheetName];
  const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
if (jsonData.length > 1) {
  jsonData[1][0] = importselectedLot.ShareClassId == 0 ? params.Asset : importselectedLot.ShareClassId; 
  jsonData[1][1] = importselectedLot.ShareClassId == 0 ? 1 : 256; 
  jsonData[1][2] = '1/31/2024';
}
jsonData.splice(2, 2); 
  const updatedWorksheet = XLSX.utils.aoa_to_sheet(jsonData);
  workbook.Sheets[sheetName] = updatedWorksheet;
  const updatedExcelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([updatedExcelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, "ReturnImportTemplate.xlsx");
  //setSelectedLot(selectedLot);
  if(importselectedLot.ShareClassId===0)
  {

  dispatch(
    getAssetValuation(
      1,
      params.Asset,
      selectedFrequencyId,
      filterDate.toISOString()
    )
  );
    }
    else
    {
      dispatch(
        getAssetValuation(
          256,
          importselectedLot.ShareClassId,
          selectedFrequencyId,
          filterDate.toISOString()
        )
      );
    }

  }
}
const titleData = {
  AssetId: importselectedLot?.ShareClassId === 0 ? params?.Asset : importselectedLot?.ShareClassId,
  EntityTypeId: importselectedLot?.ShareClassId === 0 ? 1 : 256
};
  return (
    <>
      <div id="PostReturnsDiv">
        {Loading ? (
          <>
            <LoadingScreen />
          </>
        ) : (
          <>
            <TopBar label={"Post Returns"} />
            <div>
              <div id="content" className="analytics mainContentData">
                <BreadCrumbs Levels={Level} />
                <div className="performance bg-white m-3 p-border rounded">
                  <div className="justify-content-between p-3">
                    <div className="analytics-selection bg-white p-4">
                      <div className="row gap-3">
                        <div className="col-md-3 col-lg-3">
                          <label htmlFor="select fund" className="mb-1 label">
                            Select Asset
                          </label>
                          <div className="DropDownDiv input-border">
                            <AssetDropDown
                              value={currentAsset}
                              onChange={AssestDDChanged}
                              data={AssetListDDL}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 col-lg-6">
                          <label htmlFor="select fund" className="mb-1 label">
                            Returns
                          </label>
                          <SBAComboBox
                            data={[
                              { ShareClassName: "Composite", ShareClassId: 0 },
                              ...lotsDropdownData,
                            ]}
                            value={selectedLot}
                            textField="ShareClassName"
                            valueField="ShareClassId"
                            onChange={(e) => {
                              setSelectedLot(e.value);
                            }}
                          />
                        </div>
                        <div className="col-md-3 col-lg-3 d-flex date-gap">
                          <div className="col-md-12 col-lg-12 example-wrapper">
                            <label className="mb-1 label">Select Date</label>
                            <div className="">
                              <SBDatePicker
                                value={moment(filterDate)}
                                onChange={(e) => {
                                  postPricingdateChange(e);
                                }}
                              />
                              {/* <LocalizationProvider language="en-US">
                                <DatePicker
                                    value={
                                        filterDate
                                    }
                                    weekNumber={false}
                                    format="MM/dd/yyyy"
                                    onChange={(e) => {
                                        updateParentDate(e)
                                        // setSelectedDate(e.value)
                                        setFilterDate(e.value)
                                    }}
                                    />
                                </LocalizationProvider> */}
                            </div>
                          </div>
                        </div>
                      </div>
                      <br></br>
                      {PostReturnsLotRuleAccess && (
                        <>
                          <label className="d-flex mb-4">
                            <input
                              type="checkbox"
                              checked={includeLots}
                              disabled={IsMarketable ? true : (selectedLotListButton === 1 || selectedLotListButton === 2 || selectedLotListButton === 15)}
                              onChange={() => {
                                setIncludeLots((value) => !value);
                              }}
                            />
                            <span style={{ marginLeft: "10px" }}>
                              Include Lots
                            </span>
                            <label className="d-flex ms-3">
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={handleCheckboxChange}

                              />
                              <span style={{ marginLeft: "10px" }}>
                                Hide Closed Positions
                              </span>
                            </label>
                          </label>
                          {includeLots && (
                            <div
                              style={{
                                maxHeight: "500px",
                                overflowY: "scroll",
                                maxWidth: "700px",
                                border: "1px solid #dddddd",
                              }}
                            >
                              <div className="m-2">
                                <input
                                  type="checkbox"
                                  onClick={() => {
                                    setAllLotsChecked((value) => {
                                      checkAndUnCheckAll(!value);
                                      return !value;
                                    });
                                  }}
                                  checked={allLotsChecked}
                                />
                                <label className="ms-2 label">
                                  {allLotsChecked ? (
                                    <>Uncheck All</>
                                  ) : (
                                    <>Check All</>
                                  )}
                                </label>
                              </div>

                              <SBATreeList
                                data={assetLots}
                                setdata={setAssetLots}
                                checkBox={true}
                                expandIcon={true}
                                parentValueField={"LotId"}
                                ChildrenValueField={"AssetLotId"}
                                afterExpand={afterExpand}
                                afterCheck={afterCheck}
                              />
                            </div>
                          )}
                          <br></br>
                          <div></div>
                        </>
                      )}
                      <div className="mt-3">
                        {/* <button
                        type="button"
                        className="cancel-btn"
                        onClick={clearButtonClick}
                        >
                        Clear All
                        </button> */}
                        <button
                          type="button"
                          className="p-sm-btn ms-2"
                          onClick={enterButtonClick}
                        >
                          Enter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="header-container m-3">
                  <b> List of Details </b>
                  <div className="button-container">
                    <button
                      style={{ marginRight: "10px" }}
                      className="ms-2 p-sm-btn"
                      onClick={importReturnsClick}
                    >
                      Import Returns
                    </button>
                    {LotListButtons}
                  </div>
                </div>
                <div className="m-3">
                  <div className="ag-theme-alpine" style={{ height: 420 }}>
                    <AgGridReact
                      columnDefs={listofDetailsColumnDefs}
                      rowData={gridData}
                      defaultColDef={defaultColDef}
                      ref={gridRef}
                      onCellValueChanged={onCellValueChanged}
                      rowSelection="multiple"
                      gridOptions={gridOptions}
                      onRowDataUpdated={rowDataUpdated}
                    />
                  </div>
                </div>
                <div className="m-3 d-flex justify-content-end">
                  <button className="s-sm-btn" onClick={cancelButtonClick}>
                    Cancel
                  </button>
                  <button
                    className="ms-2 p-sm-btn"
                    onClick={saveButtonClick}
                    disabled={!isEditable}
                    id="savePostBtn"
                  >
                    Save
                  </button>
                  <button
                    className="ms-2 p-sm-btn"
                    onClick={saveandCloseButtonClick}
                    disabled={!isEditable}
                    id="savePostBtn"
                  >
                    Save & Close
                  </button>
                </div>
              </div>
            </div>
            {
              <Modal show={showModal}>
                <Modal.Header closeButton onClick={closeModal}>
                  <Modal.Title>
                    Do you want to delete the selected Return?
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>
                    The selected Return will be deleted permanently. Are you
                    sure?
                  </p>
                </Modal.Body>
                <Modal.Footer>
                  <button className="s-sm-btn mx-1" onClick={closeModal}>
                    Cancel
                  </button>
                  <button
                    className="p-sm-btn mx-1"
                    onClick={onDeleteButtonClick}
                    disabled={!isEditable}
                  >
                    Yes
                  </button>
                </Modal.Footer>
              </Modal>
            }
            <SBADrawer
              open={importReturnsDrawer}
              setOpen={setImportReturns}
              close={false}
              title={`Import Returns`}
            // size={"50rem"}
            >
              <div> {importStatus === 'Importing' ? <><LoadingScreen /></> : <>
                <div className="col-lg-12 row m-0 mb-4 gap-2">
                  <div className="col-md-6">
                    <div className="mb-4">
                      <span className="fw-medium">Select Asset</span>
                      <AssetDropDown
                        value={currentAsset}
                        onChange={AssestDDChanged}
                        data={AssetListDDL}
                        popupSettings={{ className: "modalDD" }}
                       
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                  <div className="mb-4">
                      <span className="fw-medium">Time Series</span>
                          <SBAComboBox
                             data={[
                              { ShareClassName: "Composite", ShareClassId: 0 },
                              ...lotsDropdownData,
                            ]}
                            value={importselectedLot}
                            textField="ShareClassName"
                            valueField="ShareClassId"
                            onChange={(e) => {
                              setImportSelectedLot(e.value);
                            }}        
                            popupSettings={{ className: "modalDD" }}
                            title={JSON.stringify(titleData)}
                          />
                         </div>
                        </div>
                  {/* <div className="col-md-6">
                    <div className="mb-4">
                      <span className="fw-medium">
                        download fund names/symbols file
                      </span>
                    </div>
                  </div> */}
                  <div className="col-md-6">
                    <div className="mb-4">
                      <span className="fw-medium">Select File</span>
                      <input type="file" accept=".xls,.xlsx" name="selectedFile" onChange={handleFileChange} />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-4">
                    <span className="fw-medium">
                      <Link onClick={DownloadFile}> Download returns import file</Link>
                    </span>
                  </div>
                </div>
                <div className="col-lg-12 row m-0 mb-4 gap-2">
                  {/* <div className="col-md-6">
                    <div className="d-flex align-items-center mb-2">
                      <input
                        type="checkbox"
                        name="FundLots"
                        checked={drawerData.FundLots === true}
                        onChange={handleCheckbox}
                      />
                      <label className="ms-2">Apply to fund lots</label>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                      <input
                        type="checkbox"
                        name="ExistingData"
                        checked={drawerData.ExistingData === true}
                        onChange={handleCheckbox}
                      />
                      <label className="ms-2">Override existing data</label>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                      <input
                        type="checkbox"
                        name="FinalReturns"
                        checked={drawerData.FinalReturns === true}
                        onChange={handleCheckbox}
                      />
                      <label className="ms-2">
                        Mark month end returns as final
                      </label>
                    </div>
                  </div> */}
                </div>
                <div className="mt-4">
                  <button className="s-sm-btn mx-1" onClick={cancelImportReturns}>Cancel</button>
                  <button className="p-sm-btn mx-1" disabled={importStatus === 'Importing'} onClick={() => { setImportStatus('Importing'); saveImportReturns() }}>{importStatus}</button>
                </div></>}
              </div>
            </SBADrawer>
            <ToastContainer />
          </>
        )}
      </div>
    </>
  );
};
class DateEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(props.value),
    };
  }

  getValue() {
    return this.state.date;
  }

  afterGuiAttached() {
    // Focus on the DatePicker input field after it's attached
    this.datePicker.focus();
  }

  render() {
    return (
      <DatePicker
        ref={(el) => (this.datePicker = el)}
        value={this.state.date}
        onChange={(event) => this.setState({ date: event.value })}
      />
    );
  }
}
export const ReturnCellEditor = forwardRef((props, ref) => {
  const [value, setValue] = useState(props.value);
  const refInput = useRef(null);

  useImperativeHandle(ref, () => ({
    getValue() {
      return value > 999 ? 999 : value;
    },
  }));
  const handleClick = () => {
    refInput.current.focus();
  };

  return (
    <input
      ref={refInput}
      type="number"
      style={{ width: "100%" }}
      value={value}
      onChange={(event) => setValue(event.target.value)}
      onClick={handleClick}
    />
  );
});

